import {
  Article,
  TableChart,
  Layers,
  AccountTree,
  AutoFixHigh,
} from '@mui/icons-material';
import type { FeatureTour } from '../../../types';

export const consentManagementTour: FeatureTour = {
  id: 'consent-management-v1',
  priority: 2,
  requiredRole: 'researcher',
  version: 1,
  releasedAt: '2026-06-28',
  notification: {
    title: 'New: Consent Management',
    body: 'Easily create, send, and track consent forms for your study participants.',
    icon: Article,
  },
  notificationRoute: '/researcher/study/:studyId',
  steps: [
    {
      targetSelector: '[data-spotlight-id="study-tab"]',
      route: '/researcher/study/:studyId',
      icon: AccountTree,
      title: 'Navigate to Study Tools',
      body: 'Click the "Study" tab to access study-level tools including Consent Management.',
      tooltipPosition: 'bottom',
      actionLabel: 'Click Study tab \u2192',
    },
    {
      targetSelector: '[data-spotlight-id="consent-management-nav"]',
      route: '/researcher/study/:studyId',
      icon: AutoFixHigh,
      title: 'Consent Management',
      body: 'Select "Consent Management" from the Study menu to start managing consent forms.',
      tooltipPosition: 'left',
      actionLabel: 'Open Consent Mgmt \u2192',
    },
    {
      targetSelector: '[data-spotlight-id="consent-create-form"]',
      route: '/researcher/study/:studyId/consent-management',
      readySelector: '[data-spotlight-id="consent-version-picker"]:not(.Mui-disabled)',
      icon: Article,
      title: 'Create New Forms',
      body: 'Use this button to create a new consent form for your study.',
      tooltipPosition: 'left',
    },
    {
      targetSelector: '[data-spotlight-id="consent-status-table"]',
      route: '/researcher/study/:studyId/consent-management',
      icon: TableChart,
      title: 'Track Participant Consent',
      body: 'Send forms to participants, track their consent status, and view submitted forms — all from this table.',
      tooltipPosition: 'top',
    },
    {
      targetSelector: '[data-spotlight-id="consent-version-picker"]',
      route: '/researcher/study/:studyId/consent-management',
      icon: Layers,
      title: 'Manage Consent Versions',
      body: 'You can create and manage different versions of consent forms from this picker. Switch between versions to compare or activate the right one.',
      tooltipPosition: 'bottom',
      actionLabel: 'Finish',
    },
  ],
};
